export const SharingPermissions = {
  flow: 'y',
  gap: 'A',
  CaptionTitle: {
    Text: {
      text: '{{ members.sharing.title | polyglot }}'
    }
  },
  Flex: {
    gap: 'A',
    flow: 'y',
    margin: '- -Z2',
    childExtends: 'DomainItem',
    childProps: {
      align: 'start',
      Icon: null,
      Upgrade: null,
      Hgroup: {},
      Select: {
        padding: 'X Y2',
        margin: '-W -Y2 - auto',
        background: 'none',
        color: 'currentColor',
        width: 'D3+Z2',
        onChange: (ev, el, s, ctx) => {
          const value = ev.target.value
          if (value) {
            s.update({
              action: value
            })
          }
        },
        childrenAs: 'props',
        childProps: {
          tag: 'option',
          attr: {
            selected: (el, s) => el.node.value === s.action
          }
        }
      }
    },
    Guests: {
      Hgroup: {
        H: {
          text: '{{ members.sharing.previewVisibility | polyglot }}'
        },
        P: {
          text: '{{ members.sharing.previewHint | polyglot }}'
        }
      },
      Select: {
        children: [
          {
            text: '{{ members.sharing.public | polyglot }}'
          },
          {
            text: '{{ members.sharing.passwordProtected | polyglot }}'
          },
          {
            text: '{{ members.sharing.private | polyglot }}'
          }
        ]
      }
    },
    Editors: {
      Hgroup: {
        H: {
          text: '{{ members.sharing.canvasAccess | polyglot }}'
        },
        P: {
          text: '{{ members.sharing.canvasHint | polyglot }}'
        }
      },
      Select: {
        children: [
          {
            text: '{{ members.sharing.public | polyglot }}'
          },
          {
            text: '{{ members.sharing.unlisted | polyglot }}'
          },
          {
            text: '{{ members.sharing.private | polyglot }}'
          }
        ]
      }
    }
  }
}
